/* eslint-disable max-len */
import { LandingNames } from 'Pages/landings/newLandings/common/constants/LandingNames'

export const AdriverSrc = {
	[LandingNames.RBO]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4387965&bid=12389916&bn=12389916&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.RKO]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4387825&bid=12389707&bn=12389707&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.SELF_EMPLOYED]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4388062&bid=12390111&bn=12390111&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.ACQUIRING]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4387539&bid=12389339&bn=12389339&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.SALARY_PROJECT]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4387907&bid=12389825&bn=12389825&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.OKOLO]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4387934&bid=12389865&bn=12389865&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.FOODTIME]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4387858&bid=12389752&bn=12389752&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.RBO_CARD]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4387566&bid=12389368&bn=12389368&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.RKO_CARD]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4387566&bid=12390335&bn=12390335&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.FRANCHISE]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4423920&bid=12584007&bn=12584007&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.RBO_CARD_MULTI]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4423919&bid=12584248&bn=12584248&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
	[LandingNames.FRANCHISE_CARD]:
		'https://ad.adriver.ru/cgi-bin/rle.cgi?' +
		'sid=1&bt=21&ad=810753&pid=4423919&bid=12583755&bn=12583755&exss=&rnd=:RndNum4NoCash&tail256=:ar_Tail',
}
